import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log(request.url, this.authService.authToken);
    if ((request.url.startsWith('/srv/api') || request.url.startsWith('https://api.melitta.technaxis.com'))
      && this.authService.authToken) {

      const newHeaders: any = {
        Authorization: 'Bearer ' + this.authService.authToken,
      }
      // if (request.url.includes('/api/v1/admin/users/1')) {
      //   newHeaders.InitiatedAt = (Date.now()).toString();
      // }

      request = request.clone({
        setHeaders: newHeaders,
      });
    } else {
      // console.log(request.url);
    }

    return next.handle(request);
  }
}
